import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RemindPasswordComponent } from './remind-password/remind-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { QrResolverService } from './qr-resolver.service';

const routes: Routes = [
    {
        path: 'logowanie',
        children: [{
            path: '',
            component: LoginComponent,
            outlet: 'out',
            resolve: {
                qr: QrResolverService
            }
        }]
    },
    {
        path: 'zapomnialem-haslo',
        children: [{
            path: '',
            component:  RemindPasswordComponent,
            outlet: 'out',
        }]
    },
    {
        path: 'nowe-haslo',
        children: [{
            path: '',
            component:  NewPasswordComponent,
            outlet: 'out',
        }]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {
}
